// oxlint-disable-next-line typescript/no-explicit-any
export function parseContent(content: any): any {
  if (typeof content === 'string') {
    return JSON.parse(content);
  }

  return content;
}
